import {
  ADD_DEVICE_FORM,
  ADD_MASTER_DEVICE_FORM,
  ASSIGN_DEVICE_ERROR,
  ASSIGN_DEVICE_PENDING,
  ASSIGN_DEVICE_SUCCESS,
  CLEAR_ASSIGN_DEVICE_ERROR,
  CLEAR_CREATE_DEVICE_ERROR,
  CLEAR_CREATE_MASTER_DEVICE_ERROR,
  CLEAR_DEVICE_ERROR,
  CLEAR__DEVICE_DELETE_ERROR,
  CLEAR__DEVICE_LIST_ERROR,
  CLOSE_ASSIGN_DEVICE_MODAL,
  CLOSE_CREATE_DEVICE_MODAL,
  CLOSE_CREATE_MASTER_DEVICE_MODAL,
  CLOSE_DEVICE_CYCLE_MODAL,
  CLOSE_DEVICE_LOG_MODAL,
  CREATE_DEVICE_ERROR,
  CREATE_DEVICE_PENDING,
  CREATE_DEVICE_SUCCESS,
  CREATE_MASTER_DEVICE_ERROR,
  CREATE_MASTER_DEVICE_PENDING,
  CREATE_MASTER_DEVICE_SUCCESS,
  DEVICES_LIST_ERROR,
  DEVICE_CYCLE_ERROR,
  DEVICE_DELETE_CONFIRMATION_CLOSE,
  DEVICE_DELETE_CONFIRMATION_OPEN,
  DEVICE_DELETE_ERROR,
  DEVICE_LOG_ERROR,
  GET_DEVICE_CYCLE_PENDING,
  GET_DEVICE_CYCLE_SUCCESS,
  GET_DEVICE_LOG_PENDING,
  GET_DEVICE_LOG_SUCCESS,
  MASTER_DEVICES_LIST_ERROR,
  OPEN_ASSIGN_DEVICE_MODAL,
  OPEN_CREATE_DEVICE_MODAL,
  OPEN_CREATE_MASTER_DEVICE_MODAL,
  OPEN_DEVICE_CYCLE_MODAL,
  OPEN_DEVICE_LOG_MODAL,
  SET_ASSIGN_DEVICE,
  SET_CURRENT_USER_UNASSIGNED_DEVICE_LIST_ASYNC,
  SET_DEVICES_LIST,
  SET_DEVICES_PENDING,
  SET_DEVICE_CYCLE,
  SET_DEVICE_DELETE_DATA,
  SET_DEVICE_DELETE_PENDING,
  SET_DEVICE_LIST_OPTION,
  SET_DEVICE_LOG,
  SET_INITIAL_STATE,
  SET_LAST_SERIAL_NO,
  SET_MASTER_DEVICES_LIST,
  SET_MASTER_DEVICES_PENDING,
  SET_MASTER_DEVICE_KEY,
  SET_SELECTED_DEVICE_ID,
  SET_SELECTED_DEVICE,
  SET_UNASSIGNABLE_GROUPS_LIST_ASYNC,
  SET_UNASSIGNED_DEVICE_LIST_ASYNC,
  CLEAR_DEVICE_LOG,
} from "../device/actionTypes";

const initialState = {
  //-----------------------------TRANSFER DEVICE---------------------------------
  currentUserUnAssignedDevicesListAsync: [],
  //-----------------------------DEVICE LIST-------------------------------------
  devices: [],
  isGetDevicePending: false,
  deviceListErrorMsg: null,
  totalDeviceRecords: 0,
  //-----------------------------DEVICE CREATE-----------------------------------
  isCreateDeviceModalOpen: false,
  isPending: false,
  Adddeviceform: {},
  isSuccess: false,
  createDeviceError: null,
  //-----------------------------DEVICE ASSIGN-----------------------------------
  isAssignDeviceModalOpen: false,
  isAssignPending: false,
  assignDevice: {},
  isAssignSuccess: false,
  //-----------------------------DEVICE DELETE-----------------------------------
  deviceDeleteConfirmationDialogOpen: false,
  selectedDeviceDelete: null,
  isDeviceDeletePending: false,
  deviceDeleteErrorMessage: null,
  errorMessage: "",
  //-----------------------------DEVICE LOG--------------------------------------
  isDeviceLogModalOpen: false,
  isDeviceLogPending: false,
  deviceLog: null,
  deviceLogErrorMessage: null,
  selectedDevice: null,
  //-----------------------------DEVICE LIFE CYCLE--------------------------------------
  isDeviceLifeCycleModalOpen: false,
  isDeviceLifeCyclePending: false,
  selectedDeviceID: null,
  deviceLifeCycle: null,
  deviceLifeCycleErrorMessage: null,
  //-----------------------------MASTER DEVICE LIST-----------------------------------
  isGetMasterDevicesPending: false,
  masterDevices: [],
  masterDeviceListErrorMsg: null,
  totalMasterDeviceRecords: 0,
  //-----------------------------MASTER DEVICE CREATE---------------------------------
  isCreateMasterDeviceModalOpen: false,
  isCreateMasterDevicePending: false,
  masterDeviceKey: "",
  unAssignedDevicesListAsync: [],
  searchValueAsync: "",
  AddDevice: {},
  isMasterCreateSuccess: false,
  selectedDeviceList: [],
  //-----------------------------ROOM EDIT--------------------------------------------
  groupsListAsync: [],
  lastSerialNo: 0,
};

export default (localState = initialState, action) => {
  switch (action.type) {
    //--------------------------------OTEHRS---------------------------------------
    case SET_INITIAL_STATE: {
      return {
        ...initialState,
        isCreateDeviceModalOpen: true,
      };
    }
    //-----------------------------TRANSFER DEVICE---------------------------------
    case SET_CURRENT_USER_UNASSIGNED_DEVICE_LIST_ASYNC: {
      const { devicesListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        currentUserUnAssignedDevicesListAsync: devicesListAsync,
        searchValueAsync
      };
    }
    //-----------------------------DEVICE LIST-------------------------------------
    case CLEAR_DEVICE_ERROR: {
      return {
        ...localState,
        errorMessage: null,
        isSuccess: false
      };
    }
    case SET_DEVICES_PENDING: {
      return {
        ...localState,
        isGetDevicePending: true,
      };
    }
    case SET_DEVICES_LIST: {
      const { devicesOdata } = action.payload;
      return {
        ...localState,
        isGetDevicePending: false,
        devices: devicesOdata && devicesOdata['value'],
        totalDeviceRecordsCount: devicesOdata && devicesOdata["@odata.count"],
        deviceListErrorMsg: null,
        isAssignSuccess: false
      };
    }
    case CLEAR__DEVICE_LIST_ERROR: {
      return {
        ...localState,
        deviceListErrorMsg: null,
      };
    }
    case DEVICES_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        isGetDevicePending: false,
        deviceListErrorMsg: errorMessage,
        devices: [],
        totalDeviceRecordsCount: 0
      };
    }
    //-----------------------------DEVICE CREATE-----------------------------------
    case OPEN_CREATE_DEVICE_MODAL: {
      return {
        ...localState,
        isCreateDeviceModalOpen: true,
      };
    }
    case CLOSE_CREATE_DEVICE_MODAL: {
      return {
        ...localState,
        isCreateDeviceModalOpen: false,
        errorMessage: null,
      };
    }
    case CREATE_DEVICE_PENDING: {
      return {
        ...localState,
        isPending: true,
      };
    }
    case CREATE_DEVICE_SUCCESS: {
      return {
        ...localState,
        isPending: false,
        isSuccess: true,
        createDeviceError: null
      };
    }
    case CREATE_DEVICE_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        createDeviceError: errorMessage,
        isPending: false,
      };
    }
    case CLEAR_CREATE_DEVICE_ERROR: {
      return {
        ...localState,
        createDeviceError: null,
        isSuccess: false
      };
    }
    case ADD_DEVICE_FORM: {
      const { Adddeviceform } = action.payload;
      return {
        ...localState,
        Adddeviceform: Adddeviceform
      }
    }
    //-----------------------------DEVICE ASSIGN-----------------------------------
    case OPEN_ASSIGN_DEVICE_MODAL: {
      return {
        ...localState,
        isAssignDeviceModalOpen: true,
      };
    }
    case CLOSE_ASSIGN_DEVICE_MODAL: {
      return {
        ...localState,
        isAssignDeviceModalOpen: false,
        errorMessage: null
      };
    }
    case ASSIGN_DEVICE_PENDING: {
      return {
        ...localState,
        isAssignPending: true,
      };
    }
    case ASSIGN_DEVICE_SUCCESS: {
      return {
        ...localState,
        isAssignPending: false,
        isAssignSuccess: true
      };
    }
    case ASSIGN_DEVICE_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage,
        isAssignPending: false,
      };
    }
    case CLEAR_ASSIGN_DEVICE_ERROR: {
      return {
        ...localState,
        errorMessage: null,
      };
    }
    case SET_ASSIGN_DEVICE: {
      const { assignDevice } = action.payload;
      return {
        ...localState,
        assignDevice: assignDevice
      }
    }
    //-----------------------------DEVICE DELETE-----------------------------------
    case DEVICE_DELETE_CONFIRMATION_OPEN: {
      return {
        ...localState,
        deviceDeleteConfirmationDialogOpen: true,
      }
    }

    case DEVICE_DELETE_CONFIRMATION_CLOSE: {
      return {
        ...localState,
        deviceDeleteConfirmationDialogOpen: false,
      }
    }
    case SET_DEVICE_DELETE_DATA: {
      const { selectedDevice } = action.payload || {};
      return {
        ...localState,
        selectedDeviceDelete: selectedDevice,
      }
    }

    case SET_DEVICE_DELETE_PENDING: {
      return {
        ...localState,
        isDeviceDeletePending: true,
        deviceDeleteErrorMessage: null,
      }
    }

    case DEVICE_DELETE_ERROR: {
      const { errorMessage } = action.payload || {};
      return {
        ...localState,
        deviceDeleteErrorMessage: errorMessage,
        isDeviceDeletePending: false,
      }
    }

    case CLEAR__DEVICE_DELETE_ERROR: {
      return {
        ...localState,
        deviceDeleteErrorMessage: null,
        isDeviceDeletePending: false,
      }
    }
    //-----------------------------DEVICE LIFE CYCLE-------------------------------------------
    case OPEN_DEVICE_CYCLE_MODAL: {
      return {
        ...localState,
        isDeviceLifeCycleModalOpen: true,
      };
    }
    case CLOSE_DEVICE_CYCLE_MODAL: {
      return {
        ...localState,
        isDeviceLifeCycleModalOpen: false,
        deviceLifeCycleErrorMessage: null
      };
    }
    case SET_SELECTED_DEVICE_ID: {
      return {
        ...localState,
        selectedDeviceID: action.payload
      };
    }
    case GET_DEVICE_CYCLE_PENDING: {
      return {
        ...localState,
        isDeviceLifeCyclePending: true,
      };
    }
    case SET_DEVICE_CYCLE: {
      return {
        ...localState,
        deviceLifeCycle: action.payload,
        deviceLifeCycleErrorMessage: null,
      };
    }
    case GET_DEVICE_CYCLE_SUCCESS: {
      return {
        ...localState,
        isDeviceLifeCyclePending: false,
      };
    }
    case DEVICE_CYCLE_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        deviceLifeCycleErrorMessage: errorMessage,
        isDeviceLifeCyclePending: false,
        deviceLifeCycle: null
      };
    }
    //-----------------------------DEVICE LOG-------------------------------------------
    case OPEN_DEVICE_LOG_MODAL: {
      return {
        ...localState,
        isDeviceLogModalOpen: true,
      };
    }
    case CLOSE_DEVICE_LOG_MODAL: {
      return {
        ...localState,
        isDeviceLogModalOpen: false,
        deviceLogErrorMessage: null
      };
    }
    case SET_SELECTED_DEVICE: {
      return {
        ...localState,
        selectedDevice: action.payload
      };
    }
    case GET_DEVICE_LOG_PENDING: {
      return {
        ...localState,
        isDeviceLogPending: true,
      };
    }
    case SET_DEVICE_LOG: {
      return {
        ...localState,
        deviceLog: action.payload,
        deviceLogErrorMessage: null,
      };
    }
    case CLEAR_DEVICE_LOG: {
      return {
        ...localState,
        deviceLog: null,
        deviceLogErrorMessage: null,
      };
    }
    case GET_DEVICE_LOG_SUCCESS: {
      return {
        ...localState,
        isDeviceLogPending: false,
      };
    }
    case DEVICE_LOG_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        deviceLogErrorMessage: errorMessage,
        isDeviceLogPending: false,
        deviceLog: null
      };
    }
    //-----------------------------MASTER DEVICE LIST-----------------------------------
    case SET_MASTER_DEVICES_PENDING: {
      return {
        ...localState,
        isGetMasterDevicesPending: true,
      };
    }
    case SET_MASTER_DEVICES_LIST: {
      const { masterDevicesOdata } = action.payload;
      return {
        ...localState,
        isGetMasterDevicesPending: false,
        masterDeviceListErrorMsg: null,
        masterDevices: masterDevicesOdata && masterDevicesOdata['value'],
        totalMasterDeviceRecordsCount: masterDevicesOdata["@odata.count"],
      };
    }
    case MASTER_DEVICES_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        isGetMasterDevicesPending: false,
        masterDeviceListErrorMsg: errorMessage,
        masterDevices: [],
      };
    }
    //-----------------------------MASTER DEVICE CREATE---------------------------------
    case OPEN_CREATE_MASTER_DEVICE_MODAL: {
      return {
        ...localState,
        isCreateMasterDeviceModalOpen: true,
      };
    }
    case CLOSE_CREATE_MASTER_DEVICE_MODAL: {
      return {
        ...localState,
        isCreateMasterDeviceModalOpen: false,
        errorMessage: null,
      };
    }
    case ADD_MASTER_DEVICE_FORM: {
      const { AddDevice } = action.payload;
      return {
        ...localState,
        AddDevice: AddDevice
      }
    }
    case SET_MASTER_DEVICE_KEY: {
      return {
        ...localState,
        masterDeviceKey: action.payload
      }
    }
    case CREATE_MASTER_DEVICE_PENDING: {
      return {
        ...localState,
        isCreateMasterDevicePending: true,
      };
    }
    case CREATE_MASTER_DEVICE_SUCCESS: {
      return {
        ...localState,
        isCreateMasterDevicePending: false,
        isMasterCreateSuccess: true,
      };
    }
    case CREATE_MASTER_DEVICE_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage: errorMessage,
        isCreateMasterDevicePending: false,
      };
    }
    case CLEAR_CREATE_MASTER_DEVICE_ERROR: {
      return {
        ...localState,
        errorMessage: null,
        isMasterCreateSuccess: false,
      };
    }
    case SET_DEVICE_LIST_OPTION: {
      const { deviceList } = action.payload;
      return {
        ...localState,
        selectedDeviceList: deviceList
      }
    }
    case SET_UNASSIGNED_DEVICE_LIST_ASYNC: {
      const { devicesListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        unAssignedDevicesListAsync: devicesListAsync,
        searchValueAsync
      };
    }
    //-----------------------------ROOM EDIT--------------------------------------------
    case SET_UNASSIGNABLE_GROUPS_LIST_ASYNC: {
      const { groupsListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        groupsListAsync: groupsListAsync,
        searchValueAsync
      };
    }
    case SET_LAST_SERIAL_NO: {
      const { lastSerialNo } = action.payload;
      return {
        ...localState,
        lastSerialNo: lastSerialNo
      };
    }

    default: {
      return localState;
    }
  }
};
